import ServiceHelper from "./service.helper";

export default class P2PService {

    static async search(id) {
        return ServiceHelper.handleGetRequest(`/p2p_seacrh/?merchant_id=${id}`);
    }

    static async managerP2pSearch(id) {
        return ServiceHelper.handleGetRequest(`/members/p2p_seacrh/?merchant_id=${id}`);
    }

    static async managerGetMerchant(id) {
        return ServiceHelper.handleGetRequest(`/members/merchants/?merchant_id=${id}`);
    }

    static async managerGetBeneficiaryHistory(id) {
        return ServiceHelper.handleGetRequest(`/members/p2p_beneficiary_history/?merchant_id=${id}`);
    }

    static async getBeneficiaryHistory(id) {
        return ServiceHelper.handleGetRequest(`/p2p_beneficiary_history/?merchant_id=${id}`);
    }

    static async getMerchant(id) {
        return ServiceHelper.handleGetRequest(`/merchants/?merchant_id=${id}`);
    }

    static transfer(payload) {
        if(payload.user_type === 'owner') {
            return ServiceHelper.handlePostRequest("/p2p_transfer/", payload);
        }
        return ServiceHelper.handlePostRequest("/members/p2p_transfer/", payload);
    }

    static addBeneficiary(id) {
        return ServiceHelper.handlePostRequest("/beneficiaries/", {action: 'add', merchant: id});
    }

    static removeBeneficiary(id) {
        return ServiceHelper.handlePostRequest("/beneficiaries/", {action: 'remove', merchant: id});
    }

    static getBeneficiaries(userType) {
        if(userType === 'owner') {
            return ServiceHelper.handleGetRequest('/beneficiaries/')
        }
        return ServiceHelper.handleGetRequest('/members/beneficiaries/')
    }
}